import React, { useRef } from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import clsx from "clsx";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react"
import { Tooltip } from "@mui/material";
interface DropdownSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  addStyle?: string;
  showClear?: boolean;
  onClear?: () => void;
}


const DropdownSelect: React.FC<DropdownSelectProps> = ({
  value,
  onChange,
  options,
  addStyle,
  showClear = false,
  onClear
}) => {
  const handleDropdownChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value as string);
    setIsHovered(false);
  };
  const handleClose = () => {
    const isStillOver = wrapperRef.current?.matches(':hover');
    setIsHovered(isStillOver ?? false);
};
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = useState(false);
  const [suppressTooltip, setSuppressTooltip] = useState(false);
  const suppressTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  
  const tooltipOpen = isHovered && !suppressTooltip;
  
  const tooltipSuppress = () => {
    setSuppressTooltip(true);
    if (suppressTimerRef.current) clearTimeout(suppressTimerRef.current);
    suppressTimerRef.current = setTimeout(() => setSuppressTooltip(false), 1500);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
        ref={wrapperRef}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
    >
			<Tooltip title={value === 'ALL SITES' ? '' : value} placement="top-start" 
        open={tooltipOpen}
				PopperProps={{ modifiers: [ {
					name: 'offset',
					options: {
						offset: [10, -20],
					},
				},],
			}}>
      <Select
        value={value}
        onBlur={() => {setIsHovered(false)}}
        onClose={handleClose}
        onChange={(event) => {
          handleDropdownChange(event);
          tooltipSuppress();
        }}
        sx={{ 
            color: "#0093C8",
            '& .MuiSelect-select': {
                paddingRight: showClear ? '64px !important' : undefined,
            },
            '& .MuiSelect-icon': {
                fontSize: '28px',
                borderRadius: '50%',
                padding: '2px',
                transition: 'background-color 0.2s',
                right: value === 'ALL SITES' ? '2px' : undefined,
            },
            '&:hover .MuiSelect-icon': {
                backgroundColor: 'rgba(0,0,0,0.05)',
            },
        }}
        className={clsx(
          "dropdown-select",
          "!font-inter",
          "!w-[208px]",
          "!h-[52px]",
          "border-l",
          "border-transparent",
          "space-x-2",
          "!font-semibold",
          "!text-[14px]",
          "!leading-[18px]",
          addStyle
        )}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          PaperProps: {
            sx: {
              ".MuiMenuItem-root": {
                height: "36px",
                fontFamily: "inter, sans-serif",
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: "#F4F8F9 !important",
                },
              },
              ".MuiMenuItem-root.Mui-selected": {
                backgroundColor: "transparent !important",
                "&:hover": {
                  backgroundColor: "#F4F8F9 !important",
                },
                
              },
            },
          },
        }}>
        {options.map((option, index) => (
          <MenuItem
            key={`${option}-${index}`}
            value={option}
            className="!font-inter">
            {option}
          </MenuItem>
        ))}
      </Select>
			</Tooltip>
          {showClear && onClear && (
            <IconButton
              size="small"
              onClick={(e) => { e.stopPropagation(); onClear(); }}
              sx={{
                position: 'absolute',
                right: '18px',
                padding: '4px',
                color: 'rgba(0,0,0,0.54)',
              }}
              style={{
                display: isHovered ? 'inline-flex' : 'none',
              }}
            >
              <CloseIcon sx={{ fontSize: '20px' }} />
            </IconButton>
          )}
    </div>
  );
};

export default DropdownSelect;
